// Authentication actions
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

// User Actions
export const USER_EDITING = 'USER_EDITING';

//AppsComponents
export const SELECTED_APP='SELECTED_APP';
export const SELECTED_COMPONENT='SELECTED_COMPONENT';
export const GET_ALL_COMPONENT='GET_ALL_COMPONENT';

//Environments
export const SELECTED_ENVIRONMENT='SELECTED_ENVIRONMENT';
export const GET_USER_ALL_ENVIRONMENT='SELECTED_ENVIRONMENT';

//Configuration
export const SELECTED_CONFIGURATION='SELECTED_CONFIGURATION';

//Bulk Copy
export const SELECTED_CONFIGURATION_FOR_BULKCOPY='SELECTED_CONFIGURATION_FOR_BULKCOPY';

//AttributeList
export const ATTRIBUTE_LIST = 'ATTRIBUTE_LIST';

//Config Fail
export const CONFIG_FAIL='CONFIG_FAIL';


